import React from "react";

import {StyledInputDate} from "./style";

interface InputDateProps {
  date: string;
  setDate: React.Dispatch<string>;
}

export const InputDate = ({date, setDate}: InputDateProps) => {
  return (
    <StyledInputDate type="date" onChange={(e) => setDate(e.target.value)} value={date} />
  );
}